import { Select } from 'antd';
import React, { useCallback, useState } from 'react';
import { CIDADES_ARQUIVOS_SUPESP, FILE_TYPE_SUPESP } from 'utils/reutils';
import Button from 'components/button';
import { ServiceEstatisticas } from 'services/modulos/serviceEstatisticas';
import { toast } from 'react-toastify';
import { useGlobalStatistics } from 'hooks/global/useGlobalStatistics';
import { useLoadingGlobalStatistics } from 'hooks/global/useLoadingGlobalStatistics';

const { Option } = Select;

export default function StatisticsFilter() {
  const [selectedCities, setSelectedCities] = useState<string[]>(['Fortaleza']);
  const [selectedFileTypes, setSelectedFileTypes] = useState<string[]>([]);

  const { loadStatistics, handleClearStatistics } = useGlobalStatistics();

  const { loadingStatistics } = useLoadingGlobalStatistics();

  const handleLoadFiles = useCallback(() => {
    try {
      if (selectedCities.length === 0 || selectedFileTypes.length === 0) {
        toast.error('Selecione pelo menos uma cidade e um tipo de arquivo');
      }

      loadStatistics({
        cidades: selectedCities,
        tipoArquivos: selectedFileTypes,
      });
    } catch (e) {
      console.log(e);
      toast.error('Erro ao carregar arquivos, tente novamente');
    }
  }, [selectedCities, selectedFileTypes]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            gap: '2px',
          }}
        >
          <label>Cidades</label>
          <Select
            value={selectedCities}
            onChange={e => setSelectedCities(e)}
            showSearch
            style={{
              width: 200,
            }}
            virtual={false}
            notFoundContent={null}
            mode="tags"
            // defaultValue={'Fortaleza'}
            // getPopupContainer={trigger => trigger.parentElement}
            placeholder="Cidade"
            filterOption={(input, option) => {
              return Boolean(
                option?.children &&
                  String(option.children || '')
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {CIDADES_ARQUIVOS_SUPESP.map(city => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        </div>
        <div
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            gap: '2px',
          }}
        >
          <label>Arquivos</label>
          <Select
            value={selectedFileTypes}
            onChange={e => setSelectedFileTypes(e)}
            showSearch
            style={{
              width: 200,
            }}
            virtual={false}
            notFoundContent={null}
            mode="tags"
            // defaultValue={'Fortaleza'}
            // getPopupContainer={trigger => trigger.parentElement}
            placeholder="Tipos de arquivos"
            filterOption={(input, option) => {
              return Boolean(
                option?.children &&
                  String(option.children || '')
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {FILE_TYPE_SUPESP.map(type => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </div>
      </div>

      <div>
        <Button
          disabled={loadingStatistics}
          type="button"
          buttonSize="btn--small"
          onClick={handleLoadFiles}
        >
          Carregar
        </Button>
        <Button
          disabled={loadingStatistics}
          type="button"
          buttonStyle="btn--secondary"
          buttonSize="btn--small"
          onClick={handleClearStatistics}
        >
          Limpar
        </Button>
      </div>
    </div>
  );
}
